import React from "react";
import { TextField, Button, FormControl, InputLabel, Select, OutlinedInput, MenuItem, FormControlLabel, Checkbox } from '@mui/material'
import withModal from '../../Modal';
import { DatePicker } from '@mui/x-date-pickers';
import { UserRoles } from '../../../models/UserRoles';
import AuthStore from '../../../stores/Auth'
import Constants from '../../../models/Constants' 

const EditUserModal = (props: any) => {

    return (
        <div className='modal' style={{ display: 'block', zIndex: 1200, position: 'fixed', top: '20%' }} role='dialog'>
            <div className='modal-dialog'>
                <div className='modal-content'>
                    <div className='modal-body'>
                        <div className='row'>
                            <div className='col-xs-6 col-sm-6 col-md-6 co-lg-6'>
                                <TextField
                                    label='Vorname:'
                                    name='firstname'
                                    value={typeof props.user.firstname !== 'undefined' ? props.user.firstname : ''}
                                    onChange={(e:any) => props.changeNewObject(e)}
                                    fullWidth
                                    multiline />
                            </div>
                            <div className='col-xs-6 col-sm-6 col-md-6 co-lg-6'>
                                <TextField
                                    label='Nachname:'
                                    name='lastname'
                                    value={typeof props.user.lastname !== 'undefined' ? props.user.lastname : ''}
                                    onChange={(e:any) => props.changeNewObject(e)}
                                    fullWidth
                                    multiline />
                            </div>
                        </div>
                        <div className='row mt-3'>
                            <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6'>
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel htmlFor="outlined-rolle">
                                        Rolle
                                    </InputLabel>
                                    <Select
                                        input={
                                            <OutlinedInput id='outlined-rolle' fullWidth />
                                        }
                                        disabled={AuthStore.getRole() !== UserRoles[UserRoles.Administrator]}
                                        fullWidth
                                        name='userRoleId'
                                        value={typeof props.user.userRoleId !== 'undefined' ? props.user.userRoleId : ''}
                                        onChange={(e:any) => props.changeNewObject(e)}
                                    >
                                        <MenuItem value="">
                                            <em></em>
                                        </MenuItem>
                                        {props.userRoles}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6'>
                                <DatePicker
                                    label='Geburtsdatum:'
                                    name='birthdate'
                                    value={typeof props.user.birthdate !== 'undefined' ? new Date(props.user.birthdate) : null}
                                    format={Constants.DateFormat}
                                    onChange={(date: any) => {
                                        let event = {
                                            target: {
                                                name: 'birthdate',
                                                value: date
                                            }
                                        }
                                        props.changeNewObject(event)
                                    }}
                                 />
                            </div>
                        </div>
                        <div className='row mt-3'>
                            <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6'>
                                <TextField 
                                    label='Registriert'
                                    fullWidth
                                    value={props.user.registered === true ? 'ja' : 'nein'}
                                    disabled/>
                            </div>
                            <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6'>
                                <FormControlLabel control={
                                    <Checkbox
                                        style={{ color: 'rgb(0, 155, 229)' }}
                                        name='internalEmployee'
                                        checked={typeof props.user.internalEmployee != 'undefined' ? JSON.parse(props.user.internalEmployee) : false}
                                        onChange={(e:any) => {
                                            e.target.value = e.target.checked.toString()
                                            props.changeNewObject(e)
                                        }}
                                    />
                                } label="Intern" />
                            </div>
                        </div>
                        <div className='row mt-3'>
                            <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6'>
                                <TextField 
                                    label='Email'
                                    name='email'
                                    fullWidth
                                    value={typeof props.user.email != 'undefined' ? props.user.email : ''}
                                    onChange={(e:any) => props.changeNewObject(e)}/>
                            </div>
                            <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6'>
                                <TextField 
                                    label='Telefon'
                                    name='phone'
                                    fullWidth
                                    value={typeof props.user.phone != 'undefined' ? props.user.phone : ''}
                                    onChange={(e:any) => props.changeNewObject(e)}/>
                            </div>
                        </div>
                        <div className='row mt-3'>
                            <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6'>
                                <TextField 
                                    label='PLZ'
                                    name='plz'
                                    fullWidth
                                    value={typeof props.user.plz != 'undefined' ? props.user.plz : ''}
                                    onChange={(e:any) => props.changeNewObject(e)}/>
                            </div>
                            <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6'>
                                <FormControlLabel control={
                                    <Checkbox
                                        style={{ color: 'rgb(0, 155, 229)' }}
                                        name='active'
                                        disabled={AuthStore.getRole() !== UserRoles[UserRoles.Administrator]}
                                        checked={typeof props.user.active != 'undefined' ? JSON.parse(props.user.active) : false}
                                        onChange={(e:any) => {
                                            e.target.value = e.target.checked.toString()
                                            props.changeNewObject(e)
                                        }}
                                    />
                                } label="Aktiv" />
                            </div>
                        </div>
                        <div className='row mt-3'>
                            <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6'>
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel htmlFor="outlined-rolle">
                                        Benutzergruppe
                                    </InputLabel>
                                    <Select
                                        input={
                                            <OutlinedInput id='outlined-rolle' fullWidth />
                                        }
                                        disabled={AuthStore.getRole() !== UserRoles[UserRoles.Administrator]}
                                        fullWidth
                                        name='userGroupId'
                                        value={typeof props.user.userGroupId !== 'undefined' ? props.user.userGroupId : ''}
                                        onChange={(e:any) => props.changeNewObject(e)}
                                    >
                                        <MenuItem value="">
                                            <em></em>
                                        </MenuItem>
                                        {props.userGroups}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6'>
                                <TextField 
                                    label='Vereinsnummer'
                                    name='clubNumber'
                                    fullWidth
                                    value={typeof props.user.clubNumber != 'undefined' ? props.user.clubNumber : ''}
                                    onChange={(e:any) => props.changeNewObject(e)}/>    
                            </div>
                        </div>
                        <div className='row mt-3'>
                            <div className='col-6'>
                                <FormControlLabel control={
                                    <Checkbox
                                        style={{ color: 'rgb(0, 155, 229)' }}
                                        name='acceptedTerms'
                                        checked={typeof props.user.acceptedTerms != 'undefined' ? JSON.parse(props.user.acceptedTerms) : false}
                                        onChange={(e:any) => {
                                            e.target.value = e.target.checked.toString()
                                            props.changeNewObject(e)
                                        }}
                                    />
                                } label="Datenschutz" />
                            </div>
                        </div>
                    </div>
                    <div className='modal-footer'>
                        <Button
                            className='btn'
                            color='secondary'
                            variant='contained'
                            onClick={() => props.hide()}>
                            Abbrechen
                                </Button>
                        <Button
                            className='btn'
                            color='primary'
                            variant='contained'
                            onClick={() => props.submit()}>
                            Speichern
                                </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withModal(EditUserModal)